import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface CasinoGameplayState {
  gameUrl: string;
  gameName: string;
  isUrlFetched: boolean;
}

const initialState: CasinoGameplayState = {
  gameUrl: '',
  gameName: '',
  isUrlFetched: false,
};

const casinoGameplaySlice = createSlice({
  name: 'casinoGameplay',
  initialState,
  reducers: {
    setGameUrl: (state, action: PayloadAction<string>) => {
      state.gameUrl = action.payload;
    },
    setGameName: (state, action: PayloadAction<string>) => {
      state.gameName = action.payload;
    },
    setIsUrlFetched: (state, action: PayloadAction<boolean>) => {
      state.isUrlFetched = action.payload;
    },
    resetCasinoGameplayState: () => initialState,
  },
});

export const { setGameUrl, setGameName, setIsUrlFetched, resetCasinoGameplayState } =
  casinoGameplaySlice.actions;

export default casinoGameplaySlice.reducer;
